<form [formGroup]="textFg">
  <div>
    <snelstart-ui-textarea-form-control formControlName="samenStellingVerklaring"
                                        class="me-1 custom-input-800"
                                        label="Samenstellingsverklaring"
                                        [rows]="30"
                                        (change)="saveForm()"
    >
    </snelstart-ui-textarea-form-control>
  </div>
</form>
